import {Popup, Position, ToolbarItem} from 'devextreme-react/popup';
import {useEEToolAdapterContext} from "../contexts/eeToolAdapterContext";
import {SelectBox} from "devextreme-react/select-box";
import {NumberBox} from "devextreme-react/number-box";
import {useRef, useState} from "react";

export function SplashHeightPopupControl() {
    const adapterContext = useEEToolAdapterContext()
    const refSplashHeight = useRef<NumberBox>(null);

    const getOKButtonOptions = {
        stylingMode: 'contained',
        text: 'OK',
        onClick: () => {
            adapterContext.handleSplashHeight(refSplashHeight.current?.instance.option('value') ?? 0);
        },
    };

    const getCloseButtonOptions = {
        stylingMode: 'contained',
        text: 'Close',
        type: 'normal',
        onClick: () => adapterContext.hidePopupSplashHeight()
    };

    if (!adapterContext.popupSplashHeightVisible)
        return <></>;

    return (
        <>
            <Popup
                title='Enter Height of Splash'
                visible={adapterContext.popupSplashHeightVisible}
                width={adapterContext.popupSize.width}
                height={adapterContext.popupSize.height}
                hideOnOutsideClick={true}
                showCloseButton={true}
                onHidden={() => adapterContext.hidePopupSplashHeight()}
            >
                <Position at={'left top'} my={'left top'} offset={{
                    x: adapterContext.popupLocation.left,
                    y: adapterContext.popupLocation.top
                }}></Position>
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getOKButtonOptions}
                />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getCloseButtonOptions}
                />
                <div>
                    <div className="dx-field">
                        <NumberBox
                            defaultValue={adapterContext.splashHeight}
                            ref={refSplashHeight}
                            width={'100%'}
                            label='Height (in.)'
                            labelMode={'outside'}
                        />
                    </div>
                </div>
            </Popup>
        </>
    );
}
